const W = window
const D = document
const A = 'active'
const S_CONTROL = '.js-product-type-control'
const types = D.getElementById('product-types');
let slider, timeout;


const addClass = function (C) {
  this.classList.add(C)
}

const removeClass = function (C) {
  this.classList.remove(C)
}

function resize () {
  clearTimeout(timeout)
  timeout = setTimeout(function () {
    W.trigger(W, 'resize')
  }, 300)
}

const click = function (e) {
  let th = this
  e.preventDefault();
  if(!slider){
    return true
  }
  let to = th.getAttribute('data-to')
  if(to !== undefined){
    slider.goTo(to);
    D.querySelectorAll(S_CONTROL).forEach(function (value) {
      if(value === th){
        addClass.call(value, A)
      }else{
        removeClass.call(value, A)
      }
    })
  }
  resize()
}

export default function () {
  if(!types){
    return false
  }
  if(slider){
    slider.destroy()
  }
  slider = W.tns({
    "autoWidth": false,
    "items": 1,
    "gutter": 0,
    "touch": false,
    "loop": false,
    "autoHeight": true,
    "mouseDrag": false,
    "center": false,
    "swipeAngle": false,
    "controls": false,
    "nav": false,
    "navAsThumbnails": false,
    "autoplay": false,
    "container": types,
    "speed": 400
  });
  const controls = D.querySelectorAll(S_CONTROL);

  controls.forEach(function (value) {
    on(value, 'click', click)
  })
}
